/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { RolloutTypeServiceTypesSpec } from './rolloutTypeServiceTypesSpec';


/**
 * Options for target_spec when saving a plan for a rollout type.
 */
export interface RolloutTypeTargetSpecOptions { 
    type: RolloutTargetType;
    /**
     * List of supported service types and spec.
     */
    service_types_spec: Array<RolloutTypeServiceTypesSpec>;
}
export namespace RolloutTypeTargetSpecOptions {
}


